import type { ErrorStatus } from "~/types/error";

export const httpStatusCodes = new Map<number, ErrorStatus>([
  [
    400,
    {
      code: 400,
      message: "要求が正しくありません",
      description: "形式が正しくない、または無効なため、要求を処理できません。",
    },
  ],
  [
    401,
    { code: 401, message: "権限がありません", description: "リソースの必要な認証情報が見つからないか、無効です。" },
  ],
  [
    403,
    {
      code: 403,
      message: "禁止されています",
      description:
        "要求されたリソースへのアクセスが拒否されました。ユーザーに十分なアクセス許可がない可能性があります。",
    },
  ],
  [
    404,
    {
      code: 404,
      message: "お探しのページは見つかりませんでした",
      description: "アクセスしようとしたページは、削除されたかURLが変更されている可能性があります。",
    },
  ],
  [
    405,
    {
      code: 405,
      message: "メソッドが許可されていません",
      description: "要求されたHTTPメソッドはリソースで許可されていません。",
    },
  ],
  [406, { code: 406, message: "許容されません", description: "要求された形式はサポートされていません。" }],
  [
    409,
    {
      code: 409,
      message: "すでにあるリソース競合しています",
      description: "この値のリソースはすでに存在します。内容を変更して再度リクエストをお願いします。",
    },
  ],
  [
    410,
    {
      code: 410,
      message: "使用されていないリソース",
      description: "要求されたリソースはサーバーで使用できなくなっています。",
    },
  ],
  [
    412,
    {
      code: 412,
      message: "必須条件に失敗しました",
      description: "このリソースは変更されています。リソースをもう一度取得してから再試行してください。",
    },
  ],
  [413, { code: 413, message: "要求エンティティが大きすぎます", description: "要求サイズが上限を超えています。" }],
  [
    415,
    {
      code: 415,
      message: "メディアの種類がサポートされていません",
      description: "要求のコンテンツの種類がサービスによってサポートされていない形式です。",
    },
  ],
  [
    416,
    {
      code: 416,
      message: "要求された範囲が満たされません",
      description: "指定したバイト範囲が正しくない、または利用できません。",
    },
  ],
  [
    422,
    {
      code: 422,
      message: "処理できないエンティティです",
      description: "意味的に正しくないため、要求を処理できません。",
    },
  ],
  [423, { code: 423, message: "ロックされています", description: "アクセスしているリソースがロックされています。" }],
  [
    429,
    {
      code: 429,
      message: "要求数が多すぎます",
      description: "リクエストのレート制限を超えました。後でもう一度やり直してください。",
    },
  ],
  [
    500,
    {
      code: 500,
      message: "エラーが発生しました",
      description: "予期しないエラーが発生しました。後ほどアクセスをお願いします。",
    },
  ],
  [501, { code: 501, message: "実装されていません", description: "要求された機能は実装されていません。" }],
  [
    502,
    {
      code: 502,
      message: "ゲートウェイエラー",
      description: "メンテナンスまたは過負荷のため、一時的に利用できません。後ほどアクセスをお願いします。",
    },
  ],
  [
    503,
    {
      code: 503,
      message: "サービスが利用できません",
      description: "メンテナンスまたは過負荷のため、一時的に利用できません。後ほどアクセスをお願いします。",
    },
  ],
  [
    504,
    { code: 504, message: "ゲートウェイタイムアウト", description: "サーバーからの応答が時間内に受信しませんでした。" },
  ],
  [507, { code: 507, message: "記憶域の不足", description: "記憶域の最大クォータに達しました。" }],
  [
    509,
    {
      code: 509,
      message: "帯域幅の上限を超えました",
      description: "帯域幅の上限を超えたため、アプリケーションが調整されました。",
    },
  ],
]);
